import { useField, useFormikContext } from 'formik'
import get from 'lodash.get'
import { IVenueFormValues } from 'FormPage/FormPage'
import {
  Input as UIInput,
  IInputProps,
} from '@nextretreat/ui-components/dist/Input'
import { ReactComponent as SearchIcon } from 'assets/images/svg/search.svg'

interface IInputFormikProps extends Omit<IInputProps, 'name' | 'iconLeft'> {
  name: string
}

export const SearchInputFormik = ({
  invalid,
  name,
  type,
  placeholder,
  ...passingProps
}: IInputFormikProps) => {
  const { errors, touched } = useFormikContext<IVenueFormValues>()
  const [field] = useField({ name, type, placeholder })

  return (
    <UIInput
      {...passingProps}
      {...field}
      type={type}
      placeholder={placeholder}
      iconLeft={<SearchIcon />}
      invalid={invalid || !!(get(errors, name) && get(touched, name))}
    />
  )
}
